module.exports = "<div class=\"ui-g-col-12 card\">\n    <div class=\"ui-g\">\n        <h3>\n            Configuración\n        </h3>\n    </div>\n    <p-tabView>\n        <p-tabPanel header=\"Ajustes de la aplicación\">\n            <app-settings></app-settings>\n        </p-tabPanel>\n        <p-tabPanel header=\"Cambiar contraseña\">\n            <change-password-form></change-password-form>\n        </p-tabPanel>\n    </p-tabView>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/personal-config/personal-config.component.html
// module id = ./src/app/personal-config/personal-config.component.html
// module chunks = main